import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { initSentry, ErrorBoundary } from './lib/sentry.js'

// Init Sentry before React mounts so any error during the initial
// render is captured. No-op when VITE_SENTRY_DSN isn't set (local dev).
initSentry()

// Fallback shown when a render error escapes every component-level
// error handler. Plain HTML — keeps this independent of Tailwind /
// React Router state in case those are what crashed.
function CrashFallback() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      backgroundColor: '#fff',
    }}>
      <div style={{ maxWidth: 420, textAlign: 'center' }}>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
          Something went wrong.
        </div>
        <p style={{ color: '#555', fontSize: 14, lineHeight: 1.5, marginBottom: 16 }}>
          The app hit an unexpected error and our team has been notified. Try
          reloading — your data is safe.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            borderRadius: 8,
            border: 'none',
            backgroundColor: '#2563eb',
            color: '#fff',
            fontWeight: 600,
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Reload
        </button>
      </div>
    </div>
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary fallback={<CrashFallback />}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
)
